import { Component, Input, OnInit } from '@angular/core';
import { FooterLinkModel } from '../_models/footer-link.model';
import { GhostButtonType } from './../../../shared/components/ghost-button/ghost-button-type.enum';
import { FooterBottom } from './../_models/footer.model';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GhostButtonComponent } from 'src/app/shared/components/ghost-button/ghost-button.component';

@Component({
  selector: 'app-footer-products',
  templateUrl: './footer-products.component.html',
  styleUrls: ['./footer-products.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, GhostButtonComponent]
})
export class FooterProductsComponent implements OnInit {
  @Input() content: FooterBottom;
  otherProducts: FooterLinkModel[];
  GhostButtonType: typeof GhostButtonType = GhostButtonType;
  constructor() { }

  ngOnInit() {
    this.otherProducts = [
      this.content.edoApp,
      this.content.edoPost,
      this.content.sigillum,
      this.content.exciseBand,
      this.content.peopleAndDocs
    ];
  }
}
